import {Divider} from '@mui/material';
import Paper from '@mui/material/Paper';
import React from 'react';
import {OrganizationUserLicensePermissionDrawer} from './components/OrganizationUserLicensePermissionDrawer';
import {OrganizationUserPermissionDrawer} from './components/OrganizationUserPermissionDrawer';
import {OrganizationUsersHeader} from './components/OrganizationUsersHeader';
import {OrganizationUsersTable} from './components/OrganizationUsersTable';
import {useOrganizationUsersPageState} from './state/organization-users-page-state';

type Props = {
  organizationId: string
}

export const OrganizationUsersPage = ({organizationId}: Props) => {
  const state = useOrganizationUsersPageState(organizationId)

  return state.licenseDetails && state.organizationDetails && (
    <Paper sx={{height: '100%', width: '100%', padding: 2, position: 'relative'}}>
      <OrganizationUsersHeader
        organizationData={state.organizationDetails}
        licenseDetails={state.licenseDetails}
        translate={state.translate}
        translateLocal={state.translateHeader}
      />
      <Divider sx={{ my: 2 }} />
      <OrganizationUsersTable
        users={state.users}
        translate={state.translate}
        translateLocal={state.translateLocal}
        onUserLicensePermissionsClicked={(userId) => {
          state.setSelectedUserId(userId)
          state.setUserLicensePermissionDrawerOpen(true)
        }}
        onUserPermissionsClicked={(userId) => {
          state.setSelectedUserId(userId)
          state.setUserPermissionDrawerOpen(true)
        }}
      />
      {
        state.selectedUserId === null || !state.isUserLicensePermissionDrawerOpen
          ? <></>
          : <OrganizationUserLicensePermissionDrawer
            userId={state.selectedUserId}
            organizationId={organizationId}
            userName={state.selectedUserName}
            mainTableRows={state.mainTableRows}
            getChildRows={state.getChildRows}
            getFeatureDetailsId={state.getFeatureDetailsId}
            isDrawerOpen={state.isUserLicensePermissionDrawerOpen}
            onDrawerClosed={() => {
              state.setUserLicensePermissionDrawerOpen(false);
              state.setSelectedUserId(null)
            }}
          />
      }
      {
        state.selectedUserId === null || !state.isUserPermissionDrawerOpen
          ? <></>
          : <OrganizationUserPermissionDrawer
            userId={state.selectedUserId}
            userName={state.selectedUserName}
            isDrawerOpen={state.isUserPermissionDrawerOpen}
            onDrawerClosed={() => {
              state.setUserPermissionDrawerOpen(false);
              state.setSelectedUserId(null)
            }}
          />
      }
    </Paper>
  );
}
